<template>
  <sidenav :custom_class="color" :class="[isRTL ? 'fixed-end' : 'fixed-start']" v-if="showSidenav && !$route.meta.hideLayout" />
  <main class="main-content position-relative max-height-vh-100 h-100">
    <!-- nav -->
    <navbar :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
      :color="isAbsolute ? 'text-white opacity-8' : ''" :minNav="false" v-if="showNavbar && !$route.meta.hideLayout" />
    <router-view :key="$route.fullPath" />
    <Toast />

    <!-- <app-footer v-show="showFooter" /> -->
    <configurator :toggle="toggleConfigurator" :class="[showConfig ? 'show' : '', hideConfigButton ? 'd-none' : '']" />
  </main>
</template>
<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import Toast from 'primevue/toast';

import { mapMutations, mapState } from "vuex";

export default {
  name: "App",
  components: {
    Sidenav,
    Configurator,
    Navbar,
    Toast
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"])
  },
  computed: {
    ...mapState([
      "isRTL",
      "color",
      "isAbsolute",
      "isNavFixed",
      "navbarFixed",
      "absolute",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton"
    ])
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";

    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];

    if (window.innerWidth > 1200) {
      sidenav.classList.add("g-sidenav-pinned");
    }
  }
};
</script>

<style>
/* ===================================
   Add this to App.vue <style> (NOT scoped)
   =================================== */

/* Force prevent horizontal scroll everywhere */
html {
  overflow-x: hidden !important;
  max-width: 100vw !important;
  width: 100vw !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  overflow-x: hidden !important;
  max-width: 100vw !important;
  width: 100vw !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  overflow-x: hidden !important;
  max-width: 100vw !important;
  width: 100vw !important;
  box-sizing: border-box;
}

/* Fix all potential overflow sources */
* {
  box-sizing: border-box;
}

/* Main content area */
.main-content {
  overflow-x: hidden !important;
  max-width: 100%;
}

/* Containers */
.container,
.container-fluid {
  max-width: 100% !important;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  box-sizing: border-box;
}

/* Rows */
.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
  max-width: 100%;
}

/* Page header (for login/signup pages) */
.page-header {
  overflow-x: hidden !important;
  max-width: 100vw !important;
  width: 100vw !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Navbar */
.navbar {
  max-width: 100% !important;
  overflow-x: hidden !important;
}

/* Sidebar layout */
.g-sidenav-show {
  overflow-x: hidden !important;
  max-width: 100vw !important;
}

@media (min-width: 1200px) {
  .g-sidenav-show.g-sidenav-pinned .main-content {
    max-width: calc(100vw) !important;
  }
}

/* DataTable */
.p-datatable-wrapper {
  overflow-x: auto !important;
  max-width: 100%;
}

/* Cards */
.card {
  max-width: 100%;
  box-sizing: border-box;
}
</style>